<template>
  <ButtonContainer
    class="income-tax-calculator__button-container"
    data-testid="activation"
  >
    <template #button-primary>
      <ButtonPrimary
        size="large"
        :label="pageData.summary.activationSection.buttonLabel"
        :loading="isLoading"
        @click="handleRLPActivation"
      />
    </template>
  </ButtonContainer>
</template>

<script lang="ts" setup>
import { ref } from 'vue';

import { ButtonContainer, ButtonPrimary } from '@warrenbrasil/nebraska-web';

import {
  RLPPageData,
  RLPStatus,
  updateRLPStatus,
  UpdateRLPStatusValues
} from '@/modules/trade/services/rlp';
import { notify } from '@/modules/common/helpers/notification';
import { NotificationTypes } from '@/modules/common/services/http/notification';

interface Props {
  pageData: RLPPageData;
}
defineProps<Props>();

interface Emits {
  (e: 'refresh'): void;
}
const emit = defineEmits<Emits>();

const isLoading = ref(false);

const handleRLPActivation = async () => {
  try {
    isLoading.value = true;

    const data = await updateRLPStatus(UpdateRLPStatusValues.enable);

    notify({
      group: 'wrn-notifications',
      text: data.message,
      type:
        data.status === RLPStatus.Active
          ? NotificationTypes.success
          : NotificationTypes.info,
      duration: 6000
    });
    emit('refresh');
  } catch {
    notify({
      group: 'wrn-notifications',
      text: 'Não foi possível ativar o Warren RLP. Aguarde um momento e tente novamente.',
      type: NotificationTypes.error
    });
  } finally {
    isLoading.value = false;
  }
};
</script>

<style lang="less" scoped></style>
